import { render, staticRenderFns } from "./StaticsReportAdvisor.vue?vue&type=template&id=fc4a416c&scoped=true"
import script from "./StaticsReportAdvisor.vue?vue&type=script&lang=js"
export * from "./StaticsReportAdvisor.vue?vue&type=script&lang=js"
import style0 from "./StaticsReportAdvisor.vue?vue&type=style&index=0&id=fc4a416c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4a416c",
  null
  
)

export default component.exports